"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RING_STYLE = {
  gridArea: "1 / 1",
  border: "inherit",
  borderRadius: "50%"
};
function Loader() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "grid aspect-square w-20 rounded-full border-4 border-transparent border-r-muted-foreground relative left-1/2 -ml-10 mb-10 animate-spin",
    style: {
      animationDuration: "1s"
    },
    "data-sentry-component": "Loader",
    "data-sentry-source-file": "Loader.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: _objectSpread(_objectSpread({}, RING_STYLE), {}, {
        margin: 2,
        animation: "spin 2s infinite linear"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: _objectSpread(_objectSpread({}, RING_STYLE), {}, {
        margin: 8,
        animation: "spin 3s infinite linear"
      })
    })]
  });
}
var _default = exports.default = Loader;